import classnames from 'classnames';
import React from 'react';

const CSS = require('./ModalBody.module.scss');

interface ModalBodyProps {
  className?: string;
  children: any;
  [key: string]: any;
}

function ModalBody({ className, children, ...rest }: ModalBodyProps) {
  return (
    <div className={classnames(CSS.ModalBody, className)} {...rest}>
      {children}
    </div>
  );
}

export default ModalBody;
